import { render, staticRenderFns } from "./GuideTypeBadge.vue?vue&type=template&id=72fa93a2"
import script from "./GuideTypeBadge.vue?vue&type=script&lang=js"
export * from "./GuideTypeBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports